import React from 'react';

import {lowerizeFirstLetter} from '../../string-utils';
import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
	name: string;
};

// {@size small, Термин на русском}
export const SizePlugin: React.FC<Props> = ({args}) => {
	const [id, title] = args;
	return (
		<Link route={'rule'} params={{id: 'size'}} title={title} className={linkClass('size')}>
			{title}
		</Link>
	);
};
